














// TODO refactor this to the new imseq package
// import { PropType } from 'vue'; TODO use PropType instead of function
import { defineComponent, onActivated, onDeactivated, ref, Ref } from '@vue/composition-api';
import ImageSequence from './ivv/ImageSequence.vue';

interface PreLoaderData {
  defaultData: {
    loadPattern: number;
    progressInterval: number;
    imgSequenceSrcDigits: number;
    frameCount: number;
    firstFrame: number;
    preLoadAmount: number;
  };
  preLoaderData: Array<{
    filePath: string;
    minLoad: number;
    minProgress: number;
    minDownloadSpeed: number;
    preLoadAmount: number;
  }>;
}

export default defineComponent({
  name: 'IvvScroller',
  components: {
    ImageSequence,
  },
  props: {
    /**
     * width in pixels of the highest resolution image sequence
     */
    width: { type: Number, required: true },
    /**
     * height in pixels of the highest resolution image sequence
     */
    height: { type: Number, required: true },
    /**
     * The preloader data is an object, that contains two values, called preLoaderData and defaultData.
     * preLoaderData is an Array of options for the Image Preloader,
     * and defaultData are the missing values, if some options are not declared in the Array preLoaderData
     */
    preLoaderData: {
      type: Object as () => PreLoaderData,
      required: true,
    },
    /**
     * loads this amount(from 0.0-1.0), it reacts if it will be changed, if it was initially 0.1 and everything is loaded,
     * and it will be changed to e.g. 0.5, the rest will be loaded automatically.
     * it should be adjusted with @preLoaderData, and if it is below the "minProgress" of the next image sequence, only this image sequence will be taken for loading
     */
    preLoadAmount: { type: Number, default: 0.0 },
    /**
     * if negative, no high resolution will be loaded, otherwise it describes a still timeout (in milliseconds) when to load a high resolution image (the preloader with the biggest minimum download speed).
     * the timeout gets resetted after a movement occurs
     * after the timeout the high resolution image gets faded in after @highResolutionFadeInTime milliseconds
     */
    highResolutionTimeout: { type: Number, default: -1 },
    /**
     * the time amount (in milliseconds) while the fade in occurs (linear fade in)
     */
    highResolutionFadeInTime: { type: Number, default: 1000 },
  },
  setup() {
    // eslint-disable-next-line
    const imseq: Ref<any> = ref(null); // TODO do this the typescript way...
    const position = ref(0);

    function updatePosition() {
      // TODO could be customized via e.g. props
      // TODO optimize reflow/dom-relayout...
      // normalized position (0..1) where 0 is returned if the top edge of the imseq enters the viewport and 1 is returned if the bottom edge leaves the viewport
      const { top, height } = (imseq.value.$el as HTMLCanvasElement).getBoundingClientRect();
      position.value = Math.max(0, Math.min(1, 1 - (top + height) / (window.innerHeight + height)));
    }

    // TODO make this customizable in the future (currently it's hardcoded for each view class (potential for foot-gunning))
    onActivated(() => document.querySelectorAll('.view').forEach(e => e.addEventListener('scroll', () => updatePosition())));
    onDeactivated(() => document.querySelectorAll('.view').forEach(e => e.removeEventListener('scroll', () => updatePosition())));

    return {
      imseq,
      position,
    };
  },
});
